import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITimelineMarkerProps from "./type";
import stylesheet, {
    getTimelineMarkerColors,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    TimelineType
} from "../../type";
import {
    TriangleAlert as TriangleAlertIcon,
    CircleCheck as CircleCheckIcon,
    CircleX as CircleXIcon,
    Info as InfoIcon,
    type LucideIcon
} from "lucide-react-native";
import Avatar from "../../../avatar";
import Icon from "../../../icon";

export const TIMELINE_TYPE_ICONS: Record<TimelineType, LucideIcon | undefined> = {
    warning: TriangleAlertIcon,
    success: CircleCheckIcon,
    danger: CircleXIcon,
    neutral: undefined,
    info: InfoIcon
};

const TimelineMarker: FC<ITimelineMarkerProps> = ({
    icon: IconComponent,
    customTheme,
    measures,
    avatar,
    isDot,
    type
}) => {
    const {
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const currentColors = getTimelineMarkerColors({
        colors,
        type
    });

    const typeIcon = TIMELINE_TYPE_ICONS[type];

    const isIconMarker = !isDot && (!!IconComponent || !!typeIcon);

    const {
        container: containerDynamicStyle,
        dot: dotDynamicStyle
    } = useStyles({
        isFilled: isIconMarker,
        colors: currentColors,
        measures,
        radiuses,
        borders
    });

    const renderContent = () => {
        if(isIconMarker && IconComponent) {
            return <IconComponent
                customColor={currentColors.iconColor}
                size={measures.iconSize}
                color="mid"
            />;
        }

        if(isIconMarker && typeIcon) {
            return <Icon
                customColor={currentColors.iconColor}
                customTheme={customTheme}
                size={measures.iconSize}
                icon={typeIcon}
            />;
        }

        return <View
            style={dotDynamicStyle}
        />;
    };

    if(avatar) {
        return <View
            style={[
                stylesheet.container,
                containerDynamicStyle
            ]}
            aria-hidden={true}
        >
            <Avatar
                size={measures.avatarSize}
                customTheme={customTheme}
                type="neutral"
                {...avatar}
            />
        </View>;
    }

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-hidden={true}
    >
        {renderContent()}
    </View>;
};
export default TimelineMarker;
